import { configureStore } from '@reduxjs/toolkit';
import StudentReducer from '../reducers/StudentSlice';
import RoomReducer from '../reducers/RoomSlice';
import BookingReducer from '../reducers/BookingSlice';
import StaffReducer from '../reducers/StaffSlice';
import WorkerReducer from '../reducers/WorkerSlice';
import AuthReducer from '../reducers/AuthSlice';
import SalaryReducer from '../reducers/SalarySlice';
import MaintenanceReducer from '../reducers/MaintenanceSlice';
import HistoryReducer from '../reducers/HistorySlice';

export const store = configureStore({
    reducer: {
        auth: AuthReducer,
        students: StudentReducer,
        rooms: RoomReducer,
        bookings: BookingReducer,
        staffs: StaffReducer,
        workers: WorkerReducer,
        salaries: SalaryReducer,
        maintenances: MaintenanceReducer,
        histories: HistoryReducer,
    },
});